import { FaAward, FaDownload, FaCalendarAlt } from 'react-icons/fa';
import certificate1 from '../assets/Certificate for K.ATCHAYA for _PYTHON PROGRAMMING_.pdf';
import certificate2 from '../assets/f942be1a-74c0-4b1f-a3ac-58986936f2a3.pdf';
import certificate3 from '../assets/Python Full Stack Bootcamp Certificate.pdf';
import certificateUdemy from '../assets/udemy-certificate.pdf';
import certificate4 from '../assets/IMG_20250214_131444.jpg';
import certificate5 from '../assets/IMG_20250214_131534.jpg';

const certificates = [
  {
    title: 'Full Stack Web Development',
    issuer: 'Udemy',
    period: '2025',
    description: 'HTML, CSS, JavaScript, Node.js, jQuery — comprehensive full-stack course',
    file: certificateUdemy,
    color: 'from-violet-500 to-purple-600',
    icon: '🎓',
  },
  {
    title: 'Python Programming Workshop',
    issuer: 'Flyviv Academy',
    period: '2024',
    description: 'Online workshop in Python programming — Grade A',
    file: certificate1,
    color: 'from-cyan-500 to-blue-600',
    icon: '🐍',
  },
  {
    title: 'Web Development Internship',
    issuer: 'VeriTech',
    period: 'May – Jun 2024',
    description: 'One-month internship in web development — Grade A',
    file: certificate2,
    color: 'from-pink-500 to-rose-600',
    icon: '💼',
  },
  {
    title: 'Python Full Stack Bootcamp',
    issuer: 'Btree',
    period: '2024',
    description: '4-day intensive Python full stack development bootcamp — Grade A',
    file: certificate3,
    color: 'from-amber-500 to-orange-600',
    icon: '⚡',
  },
  {
    title: 'Mobile App Development',
    issuer: 'Bharathidasan University',
    period: '2022',
    description: 'Certificate in mobile application development — Grade A',
    file: certificate4,
    color: 'from-green-500 to-emerald-600',
    icon: '📱',
  },
  {
    title: '.NET Framework Internship',
    issuer: 'Marz Technology, Karaikudi',
    period: '2024',
    description: 'Internship in .NET Framework development — Grade A',
    file: certificate5,
    color: 'from-blue-500 to-indigo-600',
    icon: '🔷',
  },
];

export default function Certificates() {
  return (
    <section id="certificates" className="relative py-24 overflow-hidden">
      <div className="glow-orb w-72 h-72 bg-cyan-500 top-10 -left-20" />

      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 scroll-animate">
          
          <h2 className="section-title gradient-text">Certifications</h2>
          <div className="title-line" />
          <p className="section-subtitle">Courses and certifications I've completed</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {certificates.map((cert, i) => (
            <div
              key={i}
              className="glass-card p-6 scroll-animate"
              style={{ animationDelay: `${i * 0.1}s` }}
            >
              <div className="flex items-start gap-4 mb-4">
                <div
                  className={`w-12 h-12 rounded-xl flex items-center justify-center text-2xl flex-shrink-0 bg-gradient-to-br ${cert.color}`}
                  style={{ opacity: 0.9 }}
                >
                  {cert.icon}
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-bold text-white text-sm leading-tight mb-1">{cert.title}</h3>
                  <div className="flex items-center gap-1 text-violet-400 text-xs font-medium">
                    <FaAward size={10} /> {cert.issuer}
                  </div>
                </div>
              </div>

              <p className="text-slate-400 text-sm mb-4">{cert.description}</p>

              <div className="flex items-center justify-between">
                <span className="flex items-center gap-1 text-xs text-slate-500">
                  <FaCalendarAlt size={10} /> {cert.period}
                </span>
                <a
                  href={cert.file}
                  download
                  className="flex items-center gap-1.5 text-xs font-medium text-violet-400 hover:text-violet-300 transition-colors"
                >
                  <FaDownload size={10} /> View
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
